import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(<App />);

// Initialize monitoring and error tracking after React is rendered
import('./lib/monitoring');
